import HeadTittle from '../../../../components/HeadTittle';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { CancelIconsOptions } from '../../../../components/buttons/IconButtons';
import ReservationInformation from './ReservationInformation';
import ReservationAttendances from './ReservationAttendances';
import ReservationPolicies from './ReservationPolicies';
import ReservationApprovalComments from './ReservationApprovalComments';
import ReservationPolicyDocuments from './ReservationPolicyDocuments';
import routes from '../../../../Routes/routes';
import ReservationDetailApp from '../Functionality/ReservationDetailApp';
import DivContainerBody from '../../../../components/DivContainerBody';
import { STATUS_MODEL } from '../../../../enums/statusEnum';
import { permissionObj } from '../../../../Helpers/permission';
import CancelReservationModal from '../Modal/CancelReservationModal';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const ReservationDetail = () => {
    const {
        t,
        id,
        navigate,
        isOverdue,
        setShowCancelModal,
        showCancelModal,
        statusId,
        DEV,
        permission,
        modified, setModified,
        handleCancelEventByList,
        getInvitationsTab,
        selectedTabId,
        setSelectedTabId,
        currentTab,
        assets,
    } = ReservationDetailApp();

    if (!DEV &&
        !permission?.includes(permissionObj?.WEB_EVENT_READ) &&
        !permission?.includes(permissionObj?.WEB_EVENT_STATUS_READ)) {
        navigate(routes.forbidden);
    }
    return (
        <>
            <HeadTittle name={t('details')} link={routes.event.list} hidden={false}>
                {(DEV || permission?.includes(permissionObj?.WEB_EVENT_CANCEL) || permission?.includes(permissionObj?.WEB_EVENT_STATUS_CANCEL)) &&
                    statusId !== STATUS_MODEL.CANCELED &&
                    !isOverdue &&
                (
                        <div>
                            <ButtonAction
                                name='cancel'
                                className='btn-icon-delete'
                                Icon={CancelIconsOptions}
                                onClick={() => setShowCancelModal(true)}
                            />
                        </div>
                    )}
            </HeadTittle>

            <DivContainerBody>
                <div className={"row mb-4"}>
                    <div className='col-sm-12 col-md-6 col-lg-5 col-xl-4'>
                        <ReservationInformation
                            id={id}
                            t={t}
                            navigate={navigate}
                            DEV={DEV}
                            permission={permission}
                            isOverdue={isOverdue}
                        />
                    </div>
                    <div className='col-sm-12 col-md-6 col-lg-7 col-xl-8'>
                        <ReservationAttendances
                            t={t}
                            statusId={statusId}
                            getInvitationsTab={getInvitationsTab}
                            modified={modified}
                            setModified={setModified}
                            selectedTabId={selectedTabId}
                            setSelectedTabId={setSelectedTabId}
                            currentTab={currentTab}
                            DEV={DEV}
                            permission={permission}
                            isOverdue={isOverdue}
                        />
                    </div>
                </div>
                <div className='row mb-5'>
                    <div className='col-sm-12 col-md-4 col-lg-3 col-xl-3'>
                        <ReservationPolicies t={t} />
                    </div>
                    <div className='col-sm-12 col-md-4 col-lg-5 col-xl-5'>
                        <ReservationApprovalComments  t={t}/>
                    </div>
                    <div className='col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                        <ReservationPolicyDocuments t={t} assets={assets}/>
                    </div>
                </div>
            </DivContainerBody>

            {showCancelModal && (
                <CancelReservationModal
                    title='cancel_reservation'
                    show={showCancelModal}
                    onHide={() => setShowCancelModal(false)}
                    onConfirm={(description) => handleCancelEventByList(description)}
                    t={t}
                />
            )}
        </>
    );
};

export default ReservationDetail;
